import { render } from "./detail.vue?vue&type=template&id=09c2b770&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=09c2b770&lang=scss&scoped=true"
import "./detail.vue?vue&type=style&index=1&id=09c2b770&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c2b770"]])

export default __exports__